import AccountHeader from './AccountHeaderContainer';

export default AccountHeader;
